import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import Tooltip from '../Tooltip';

const tooltipHideDelay = 150;
const tooltipShowDelay = 300;

const premiumTooltipContent = (membershipUrl, isRegisterUrl) => (
  <span>
    This brand has a premium profile.&nbsp;
    <a
      tabIndex="0"
      role="button"
      href={membershipUrl}
      target="_blank"
      rel="noreferrer"
      onClick={() => !membershipUrl && window.Intercom('show')}
    >
      {isRegisterUrl ? 'Become a Member' : 'Learn More'}
    </a>
    {isRegisterUrl && <span> and build your profile for free.</span>}
  </span>
);

const SIZES = {
  SMALL: 's',
  BASE: 'base',
  LARGE: 'l',
};

export default class PremiumBadge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      size, isPremium, membershipUrl, isRegisterUrl,
    } = this.props;

    return (
      <>
        {isPremium
        && (
        <Tooltip
          placement="bottom"
          delayHide={tooltipHideDelay}
          delayShow={tooltipShowDelay}
          tooltip={premiumTooltipContent(membershipUrl, isRegisterUrl)}
          small
        >
          <span className="cursor-pointer blue">
            <span
              className="verified"
              style={{
                fontSize: size === SIZES.SMALL ? '2rem' : '2.5rem',
                top: '4px',
                position: 'relative',
              }}
            >
              +
            </span>
            <span
              className={`pl-xxxs ${size === SIZES.SMALL ? 'fs-s' : 'fs-base'}`}
              style={{ position: 'relative', top: '-3px' }}
            >
              Premium
            </span>
          </span>
        </Tooltip>
        )}
      </>
    );
  }
}

PremiumBadge.propTypes = {
  isPremium: PropTypes.bool,
  size: PropTypes.string,
  membershipUrl: PropTypes.string,
  isRegisterUrl: PropTypes.bool,
};

PremiumBadge.defaultProps = {
  isPremium: false,
  size: SIZES.BASE,
  membershipUrl: null,
  isRegisterUrl: false,
};

Object.values(document
  .querySelectorAll('.premium-badge'))
  .filter(e => typeof e === 'object')
  .forEach((container) => {
    const rawIsPremium = container.getAttribute('data-is-premium');
    const badgeSize = container.getAttribute('data-size');
    const membershipUrl = container.getAttribute('data-membership-url') || null;
    const isRegisterUrl = container.hasAttribute('data-is-register-url');
    const isPremium = typeof rawIsPremium === 'string' && rawIsPremium.toLowerCase() === 'true';
    ReactDOM.render(<PremiumBadge
      isPremium={isPremium}
      size={badgeSize}
      membershipUrl={membershipUrl}
      isRegisterUrl={isRegisterUrl}
    />,
    container);
  });
